module.exports = __webpack_public_path__ + "img/SANTANDER_Credit_Light.645d7725.png";